// ISO-3166 alpha-2 → { name, flag } minimal lookup for the analytics dashboard.
// Covers the 60+ countries most likely to visit Padel Gems (GCC + Levant +
// APAC + EU + Americas). Unknown codes fall back to "Unknown / ??".

const COUNTRIES = {
  SA: { name: 'Saudi Arabia', flag: '🇸🇦' },
  AE: { name: 'United Arab Emirates', flag: '🇦🇪' },
  KW: { name: 'Kuwait', flag: '🇰🇼' },
  QA: { name: 'Qatar', flag: '🇶🇦' },
  BH: { name: 'Bahrain', flag: '🇧🇭' },
  OM: { name: 'Oman', flag: '🇴🇲' },
  YE: { name: 'Yemen', flag: '🇾🇪' },
  IQ: { name: 'Iraq', flag: '🇮🇶' },
  JO: { name: 'Jordan', flag: '🇯🇴' },
  LB: { name: 'Lebanon', flag: '🇱🇧' },
  SY: { name: 'Syria', flag: '🇸🇾' },
  PS: { name: 'Palestine', flag: '🇵🇸' },
  IL: { name: 'Israel', flag: '🇮🇱' },
  EG: { name: 'Egypt', flag: '🇪🇬' },
  MA: { name: 'Morocco', flag: '🇲🇦' },
  DZ: { name: 'Algeria', flag: '🇩🇿' },
  TN: { name: 'Tunisia', flag: '🇹🇳' },
  LY: { name: 'Libya', flag: '🇱🇾' },
  SD: { name: 'Sudan', flag: '🇸🇩' },
  TR: { name: 'Turkey', flag: '🇹🇷' },
  IR: { name: 'Iran', flag: '🇮🇷' },
  IN: { name: 'India', flag: '🇮🇳' },
  PK: { name: 'Pakistan', flag: '🇵🇰' },
  BD: { name: 'Bangladesh', flag: '🇧🇩' },
  LK: { name: 'Sri Lanka', flag: '🇱🇰' },
  NP: { name: 'Nepal', flag: '🇳🇵' },
  AF: { name: 'Afghanistan', flag: '🇦🇫' },
  MM: { name: 'Myanmar', flag: '🇲🇲' },
  TH: { name: 'Thailand', flag: '🇹🇭' },
  VN: { name: 'Vietnam', flag: '🇻🇳' },
  MY: { name: 'Malaysia', flag: '🇲🇾' },
  SG: { name: 'Singapore', flag: '🇸🇬' },
  ID: { name: 'Indonesia', flag: '🇮🇩' },
  PH: { name: 'Philippines', flag: '🇵🇭' },
  HK: { name: 'Hong Kong', flag: '🇭🇰' },
  TW: { name: 'Taiwan', flag: '🇹🇼' },
  CN: { name: 'China', flag: '🇨🇳' },
  JP: { name: 'Japan', flag: '🇯🇵' },
  KR: { name: 'South Korea', flag: '🇰🇷' },
  MN: { name: 'Mongolia', flag: '🇲🇳' },
  KZ: { name: 'Kazakhstan', flag: '🇰🇿' },
  UZ: { name: 'Uzbekistan', flag: '🇺🇿' },
  AZ: { name: 'Azerbaijan', flag: '🇦🇿' },
  AM: { name: 'Armenia', flag: '🇦🇲' },
  GE: { name: 'Georgia', flag: '🇬🇪' },
  GB: { name: 'United Kingdom', flag: '🇬🇧' },
  IE: { name: 'Ireland', flag: '🇮🇪' },
  FR: { name: 'France', flag: '🇫🇷' },
  DE: { name: 'Germany', flag: '🇩🇪' },
  ES: { name: 'Spain', flag: '🇪🇸' },
  IT: { name: 'Italy', flag: '🇮🇹' },
  NL: { name: 'Netherlands', flag: '🇳🇱' },
  BE: { name: 'Belgium', flag: '🇧🇪' },
  AT: { name: 'Austria', flag: '🇦🇹' },
  CH: { name: 'Switzerland', flag: '🇨🇭' },
  PT: { name: 'Portugal', flag: '🇵🇹' },
  GR: { name: 'Greece', flag: '🇬🇷' },
  CZ: { name: 'Czech Republic', flag: '🇨🇿' },
  PL: { name: 'Poland', flag: '🇵🇱' },
  HU: { name: 'Hungary', flag: '🇭🇺' },
  RO: { name: 'Romania', flag: '🇷🇴' },
  BG: { name: 'Bulgaria', flag: '🇧🇬' },
  SE: { name: 'Sweden', flag: '🇸🇪' },
  NO: { name: 'Norway', flag: '🇳🇴' },
  FI: { name: 'Finland', flag: '🇫🇮' },
  DK: { name: 'Denmark', flag: '🇩🇰' },
  RU: { name: 'Russia', flag: '🇷🇺' },
  UA: { name: 'Ukraine', flag: '🇺🇦' },
  BY: { name: 'Belarus', flag: '🇧🇾' },
  US: { name: 'United States', flag: '🇺🇸' },
  CA: { name: 'Canada', flag: '🇨🇦' },
  MX: { name: 'Mexico', flag: '🇲🇽' },
  BR: { name: 'Brazil', flag: '🇧🇷' },
  AR: { name: 'Argentina', flag: '🇦🇷' },
  CO: { name: 'Colombia', flag: '🇨🇴' },
  CL: { name: 'Chile', flag: '🇨🇱' },
  PE: { name: 'Peru', flag: '🇵🇪' },
  VE: { name: 'Venezuela', flag: '🇻🇪' },
  NG: { name: 'Nigeria', flag: '🇳🇬' },
  GH: { name: 'Ghana', flag: '🇬🇭' },
  KE: { name: 'Kenya', flag: '🇰🇪' },
  TZ: { name: 'Tanzania', flag: '🇹🇿' },
  ET: { name: 'Ethiopia', flag: '🇪🇹' },
  UG: { name: 'Uganda', flag: '🇺🇬' },
  ZA: { name: 'South Africa', flag: '🇿🇦' },
  AU: { name: 'Australia', flag: '🇦🇺' },
  NZ: { name: 'New Zealand', flag: '🇳🇿' },
  FJ: { name: 'Fiji', flag: '🇫🇯' },
};

// Fallback: derive a flag emoji from an ISO-2 code programmatically. This
// works for every valid code even if it's not in the lookup above.
const flagFromCode = (code) => {
  if (!code || code.length !== 2) return '🌐';
  const A = 0x1F1E6; // Regional Indicator Symbol Letter A
  const base = 'A'.charCodeAt(0);
  const cc = code.toUpperCase();
  try {
    return String.fromCodePoint(A + (cc.charCodeAt(0) - base), A + (cc.charCodeAt(1) - base));
  } catch {
    return '🌐';
  }
};

export const countryInfo = (code) => {
  if (!code || code === '??' || code === 'XX') {
    return { name: 'Unknown', flag: '🌐', code: '??' };
  }
  const c = code.toUpperCase();
  const entry = COUNTRIES[c];
  return {
    name: entry?.name || c,
    flag: entry?.flag || flagFromCode(c),
    code: c,
  };
};

// Friendly labels for common site paths / SPA sections.
export const PAGE_LABELS = {
  '/': 'Homepage',
  '/admin/login': 'Admin login',
  '/admin/overview': 'Admin — Overview',
  '/admin/content': 'Admin — Content Studio',
  '/admin/analytics': 'Admin — Analytics',
  '/admin/calendar': 'Admin — Calendar',
  '/admin/clients': 'Admin — Clients',
  '/admin/invoices': 'Admin — Invoices',
  '/admin/bookings': 'Admin — Bookings',
  '/admin/messages': 'Admin — Messages',
  '/admin/services': 'Admin — Services',
  '/admin/testimonials': 'Admin — Testimonials',
  '/admin/settings': 'Admin — Settings',
};

export const pageLabel = (path) => PAGE_LABELS[path] || path || '/';

export default COUNTRIES;
